import { render } from "./Blog.vue?vue&type=template&id=ea796a6a"
const script = {}

import "./Blog.vue?vue&type=style&index=0&id=ea796a6a&lang=css"
script.render = render

export default script